import { SmartDataTitle, TextClamp } from '@ctek/design-system';
import React from 'react';

interface SmartTextWrapperProps {
  isSmart?: boolean;
  isUppercase?: boolean;
  children: React.ReactNode;
}

export const SmartTextWrapper = ({ isSmart, isUppercase = true, children }: SmartTextWrapperProps) => {
  if (isSmart) {
    return (
      <SmartDataTitle>
        <TextClamp isUppercase={isUppercase}>{children}</TextClamp>
      </SmartDataTitle>
    );
  }

  return <TextClamp isUppercase={isUppercase}>{children}</TextClamp>;
};
